import qz from "qz-tray";
import { api } from "@/lib/api";
import { brl, PAYMENT } from "@/lib/format";

const KEY = "primo_printer_cfg";
export const DEFAULT_CFG = { method: "browser", printer: "", width: 80, autoPrint: false };

export const loadPrinterCfg = () => ({ ...DEFAULT_CFG, ...JSON.parse(localStorage.getItem(KEY) || "{}") });
export const savePrinterCfg = (cfg) => localStorage.setItem(KEY, JSON.stringify(cfg));

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function receiptHTML(order, store, width) {
  const px = width === 58 ? 196 : 272;
  const fs = width === 58 ? 13 : 16;
  const items = order.items
    .map((i) => `<tr><td>${i.qty}x ${esc(i.name)}${(i.selections || []).length ? `<div class="sub">${i.selections.map((s) => `- ${s.qty}x ${esc(s.option)}${s.price ? ` (+${brl(s.price)})` : ""}`).join("<br>")}</div>` : ""}</td><td class="r">${brl(i.subtotal)}</td></tr>`)
    .join("");
  const change = order.payment_method === "dinheiro" && order.change_for
    ? `<div>Troco para: ${brl(order.change_for)} (troco ${brl(order.change_for - order.total)})</div>` : "";

  const via = (label, last) => `
<div class="via${last ? " last" : ""}">
<h1>DEPÓSITO DO PRIMO</h1>
${store?.store_address ? `<div class="c">${esc(store.store_address)}</div>` : ""}
${store?.store_phone ? `<div class="c">Tel: ${esc(store.store_phone)}</div>` : ""}
<hr>
<div class="big c">PEDIDO #${order.number}</div>
<div class="c">${new Date(order.created_at).toLocaleString("pt-BR")}</div>
<div class="c">${order.fulfillment === "entrega" ? "*** ENTREGA ***" : "*** RETIRADA ***"}</div>
<div class="c">${label}</div>
<hr>
<div>Cliente: ${esc(order.customer_name)}</div>
<div>Tel: ${esc(order.phone)}</div>
${order.fulfillment === "entrega" ? `<div>End.: ${esc(order.address)}</div>` : ""}
${order.notes ? `<div>Obs.: ${esc(order.notes)}</div>` : ""}
<hr>
<table>${items}</table>
<hr>
<table>
<tr><td>Subtotal</td><td class="r">${brl(order.subtotal)}</td></tr>
<tr><td>Taxa de entrega</td><td class="r">${brl(order.delivery_fee)}</td></tr>
${order.discount ? `<tr><td>Desconto ${esc(order.coupon_code || "")}</td><td class="r">-${brl(order.discount)}</td></tr>` : ""}
</table>
<div class="total"><span>TOTAL</span><span>${brl(order.total)}</span></div>
<hr>
<div>Pagamento: ${PAYMENT[order.payment_method]}</div>
${order.payment_method === "pix" ? `<div>** ENVIAR COMPROVANTE DO PIX **</div>` : ""}
${change}
<hr>
<div class="c">Obrigado pela preferência!</div>
<div class="c">______________________</div><div class="c">Assinatura</div>
<div class="cut">&nbsp;</div>
</div>`;

  return `<!doctype html><html><head><meta charset="utf-8"><style>
@page { size: ${width}mm auto; margin: 0; }
* { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
html, body { margin: 0; padding: 0; background: #fff; }
body, body * {
  font-family: 'Courier New', Courier, monospace;
  font-size: ${fs}px;
  font-weight: 900;
  color: #000;
  opacity: 1;
  line-height: 1.35;
  -webkit-text-stroke: 0.2px #000;
}
body { padding: 4px 2px; width: ${px}px; }
.via { width: 100%; overflow-wrap: break-word; word-wrap: break-word; word-break: break-word; page-break-after: always; break-after: page; }
.via.last { page-break-after: auto; break-after: auto; }
h1, h1 * { font-size: ${fs + 4}px; text-align: center; margin: 0 0 2px; }
.big, .big * { font-size: ${fs + 4}px; }
.total, .total span { font-size: ${fs + 8}px; white-space: nowrap; }
.total { display: flex; justify-content: space-between; gap: 6px; padding-top: 4px; }
.c { text-align: center; }
.r { text-align: right; white-space: nowrap; }
.sub { padding-left: 10px; }
hr { border: none; border-top: 2px dashed #000; margin: 6px 0; }
table { width: 100%; border-collapse: collapse; table-layout: fixed; }
td { vertical-align: top; padding: 1px 0; overflow-wrap: break-word; word-break: break-word; }
td.r { width: 32%; }
.cut { text-align: center; margin: 8px 0 10px; }
</style></head><body>
${via("VIA 1 - CLIENTE")}
${via("VIA 2 - LOJA", true)}
</body></html>`;
}

function printBrowser(html) {  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => iframe.remove(), 1000);
  }, 250);
}

export async function qzConnect() {
  if (qz.websocket.isActive()) return;
  let signed = false;
  try {
    const { data } = await api.get("/qz/certificate", { responseType: "text" });
    if (data && String(data).includes("BEGIN CERTIFICATE")) {
      qz.security.setCertificatePromise((resolve) => resolve(String(data)));
      qz.security.setSignatureAlgorithm("SHA512");
      qz.security.setSignaturePromise((toSign) => async (resolve, reject) => {
        try {
          const res = await api.post("/qz/sign", toSign, { headers: { "Content-Type": "text/plain" }, responseType: "text" });
          resolve(String(res.data).trim());
        } catch (e) { reject(e); }
      });
      signed = true;
    }
  } catch (e) { /* sem certificado: segue no modo não assinado */ }
  if (!signed) {
    qz.security.setCertificatePromise((resolve) => resolve());
    qz.security.setSignaturePromise(() => (resolve) => resolve());
  }
  await qz.websocket.connect({ retries: 1, delay: 1 });
}

export async function qzListPrinters() {
  await qzConnect();
  return qz.printers.find();
}

async function printQZ(html, cfg) {
  if (!cfg.printer) throw new Error("Selecione uma impressora nas Configurações");
  await qzConnect();
  const config = qz.configs.create(cfg.printer, { units: "mm", size: { width: cfg.width }, margins: 0, scaleContent: true });
  await qz.print(config, [{ type: "pixel", format: "html", flavor: "plain", data: html }]);
}

export async function printOrder(order, store) {
  const cfg = loadPrinterCfg();
  const html = receiptHTML(order, store, cfg.width);
  if (cfg.method === "qz") return printQZ(html, cfg);
  printBrowser(html);
}
